import clickTracking from 'tracking/sdk/recordView/clickTracking'
import createRecorder from 'tracking/sdk/recordView/record'
import VueRouter from 'vue-router'

import { trackingBaseUrl } from '@/data/appConfig'
import GoogleOptimizeService from '@/sdk/googleOptimize'

import TagManager from './src/gtm'

interface CareshipTrackingConfig {
  router: VueRouter
}

declare const dataLayer: Array<Object>

export default function installCareshipTracking(
  Vue,
  config: CareshipTrackingConfig,
) {
  initRouterGuard(Vue, config)

  // Add to vue prototype and also from globals
  Vue.prototype.$gtm = Vue.gtm = new TagManager()
  Vue.prototype.$optimize = Vue.optimize = GoogleOptimizeService()
}

// @TODO: don't pass Vue, simply use the tracking methods directly
function initRouterGuard(Vue, config: CareshipTrackingConfig) {
  const { router } = config
  const record = createRecorder(trackingBaseUrl)
  const trackClick = clickTracking(trackingBaseUrl)

  router.afterEach(to => {
    const pageName = (to.meta && to.meta.gtm) || to.name
    const pagePath = to.path
    const hostName = window.location.hostname
    const urlParameters =
      Object.keys(to.query)
        .map(key => `${key}=${to.query[key]}`)
        .join('&') + to.hash

    dataLayer.push({ event: 'optimize.activate' })

    Vue.gtm.trackView(pageName, to.fullPath)
    record(hostName, pagePath, urlParameters)
    trackClick.recordClick()
  })
}
